import moment from "moment-timezone";

export interface ILiquidityIndicator {
  issuer_name?: string;
  today_transactions?: number | null;
  today_volume_lakhs?: number | null;
  last_3m_transactions?: number | null;
  last_3m_volume_lakhs?: number | null;
  last_data_timestamp?: string | null;
}

const formatMetric = (value: number | null | undefined, fractionDigits: number) =>
  new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: fractionDigits,
  }).format(typeof value === "number" && Number.isFinite(value) ? value : 0);

export const getLiquidityIndicatorDisplay = (data: ILiquidityIndicator) => {
  const timestamp = data.last_data_timestamp
    ? moment.tz(data.last_data_timestamp, moment.ISO_8601, true, "Asia/Kolkata")
    : null;
  const validTimestamp = timestamp?.isValid() ? timestamp : null;

  return {
    todayTransactions: formatMetric(data.today_transactions, 0),
    todayVolumeLakhs: `₹${formatMetric(data.today_volume_lakhs, 1)}`,
    last3mTransactions: formatMetric(data.last_3m_transactions, 0),
    last3mVolumeLakhs: `₹${formatMetric(data.last_3m_volume_lakhs, 1)}`,
    asOnDate: validTimestamp?.format("MMM, Do YYYY") ?? "--",
    lastUpdated: validTimestamp?.format("MMM, Do YYYY hh:mm A") ?? "--",
  };
};
